import { render, staticRenderFns } from "./WProducts.vue?vue&type=template&id=1185b2df&"
import script from "./WProducts.vue?vue&type=script&lang=js&"
export * from "./WProducts.vue?vue&type=script&lang=js&"
import style0 from "./WProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WPrice from '@/components/WPrice.vue'
import WSwitch from '@/components/WSwitch.vue'
autoInstallComponents(component, {WPrice,WSwitch})
